'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import 'select2';

/**
 * filterBar
 * separate logic for filterBar event listener
 * also update-function tyreSelector can call to update filterBar based on results tyreSelector got
 */

let filterBar = {
  filterBarEl: $('#filter-bar:first'),
  language: $(document.body).data('language'),
  filterBarUpdatedFor: null,

  // Depends on tyreSelector results
  updateFilterBar: function(formName) {
    // This function
    // 1) updates the results-list inside .filter-bar. It creates new links (<a>) from radio-button-results inside license/model forms.
    // 2) builds a <select> element for MOBILE view: it replaces separate size links with a single dropdown to save UI space.

    if (typeof formName === 'undefined' || !formName) return false;

    if (this.filterBarUpdatedFor) {
      return false;
    }
    this.filterBarUpdatedFor = formName;

    var form = $('form[name="' + formName + '"]');
    if (!form.length) return false;
    var resultsEl = $(form).find('.results'), // this is the old results el inside the form. This element is hidden with styles but used when populating the newResultsEl outside the form.
      results = resultsEl.length ? $(form).find('.results .result') : {};

    // clone resultsEl to filter-bar
    const tsViewId = $(form)
        .parents('.tsView')
        .attr('id'),
      newResultsEl = $('[data-tab="#' + tsViewId + '"]');

    if (!results.length ) {
      newResultsEl.html('');
    } else if (results.length) {

      var sizesData = [];

      $(results).each(function(i, result) {
        var input = $(result).find('input:first'),
          sizeString = $(input).val() ? $(input).val() : '',
          selected = $(input).is(':checked'),
          disabled = $(input).is(':disabled'),
          defaultSize = $(input).attr('data-manufacturer-default') === 'true',
          splitted = sizeString.split(','),
          width = null,
          height = null,
          rim = null,
          path = window.tsSettings.targetUrl;

        if (splitted.length > 2) {
          width = splitted[0];
          height = splitted[1];
          rim = splitted[2];
        } // values found

        var _data = {
          path: path,
          size: sizeString,
          selected: selected,
          disabled: disabled,
          defaultSize: defaultSize,
          width: width,
          height: height,
          rim: rim
        };

        sizesData.push(_data);
      });

      // for the select element with optgroups, sizesData needs to be splitted by rim size
      var sizesDataByRim = [];
      var lastSize = null;
      var groupedSizesArr = [];
      for (var i = 0; i < sizesData.length; i++) {
        var s = sizesData[i];

        if (s.rim !== lastSize) {
          // push store current group
          if (groupedSizesArr.length) {
            sizesDataByRim.push(groupedSizesArr);
          }
          // create new group
          groupedSizesArr = [];
          lastSize = s.rim;
        }

        groupedSizesArr.push(s);

        if (i === sizesData.length - 1) {
          // last one > store
          sizesDataByRim.push(groupedSizesArr);
        }
      }

      // add elements into .filter-bar
      if (newResultsEl.length) {
        var sizesHtml = Mustache.render(window.filter_bar_sizes_template, {
          sizesByRim: sizesDataByRim
        });
        $(newResultsEl)
          .html(sizesHtml)
          .show();
        $(newResultsEl)
          .parents('.sizes-wrap')
          .show();
      }

      // add select2 to dropdown
      newResultsEl
        .find('select[name="mobileTyreSize"]')
        .select2({ minimumResultsForSearch: Infinity });
    } // results found
  }, // updateFilterBar()


  // =========================================
  // INIT FUNCTION
  // =========================================

  init: function() {
    console.log('filterBar.init()');

    // filterGroup dropdown.
    $(document).on('change', 'select[name="filterGroup"]', function(e) {
      const value = $(this).val();
      document.location.href = value;
    });

    // attach select2 to filterGroup
    $('select[name="filterGroup"]').select2();

    // filter-bar link should store clicked tyre size info to session
    $(document).on('click', '.filter-bar a[data-size]', function(e) {
      const splitted = $(this).attr('data-size')
        ? $(this)
          .attr('data-size')
          .split(',')
        : [];
      const width = ~~splitted[0];
      const height = ~~splitted[1];
      const rim = ~~splitted[2];
      if (width && height && rim && window.cookieObj) {
        e.preventDefault();
        window.cookieObj.width = width;
        window.cookieObj.height = height;
        window.cookieObj.rim = rim;
        window.setTyreCookie();
        document.location.href = $(this).attr('href');
      }
    });
  } // init()
};

export default filterBar;
